import { Connector } from '@web3-wallet/core';
import { icon } from './assets';
const _name = 'Brave Wallet';
export const name = _name;
export class BraveWallet extends Connector {
    constructor() {
        super(...arguments);
        this.name = name;
    }
}
BraveWallet.walletName = name;
BraveWallet.walletIcon = icon;
